/**
 * Lädt die externe config.js und wartet, bis die Datei geladen ist.
 * Gibt ein Promise zurück, das die Config enthält.
 */
export function loadConfig() {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "/info_config/config_urls.js";  // Pfad, unter dem Tomcat die Datei ausliefert
        script.onload = () => {
            if (window.APP_CONFIG) {
                resolve(window.APP_CONFIG);
            } else {
                reject("APP_CONFIG wurde nicht gefunden.");
            }
        };
        script.onerror = () => reject("config_urls.js konnte nicht geladen werden.");
        document.head.appendChild(script);
    });
}
